import { getCookie } from "@/components/ChapterPage/communityCommon.constant";

export const wrapHbRedirectsWithGACookie = (url) => {
    const gaCookie = getCookie('_ga');
    return gaCookie ? `${url}?_ga=${gaCookie}` : url;
};
import { routerNames } from "@/components/appCommon.constants";

export const routesToNavigateToHivebrite = [
    routerNames.CHAPTER.toLowerCase(),
    routerNames.NETWORK.toLowerCase(),
    routerNames.GROUP.toLowerCase(),
];

export const getHbRedirectByCommunityId = (communityList, communityId) => {
    return communityList && communityList.length && communityId
        ? communityList.find(community => community.communityId.toLowerCase() === communityId.toLowerCase())
        : null;
};
